{
  "name": "waytr-qr",
  "version": "0.9.6",
  "description": "Waytr is a SAAS platform which provides the ability to easily order at a venue",
  "author": {
    "name": "Andrei Lazar",
    "email": "andreimhlazar@gmail.com",
    "url": "https://github.com/AndreiMLazar"
  },
  "contributors": [
    {
      "name": "Laurentiu Ene",
      "email": "laurrene@gmail.com",
      "url": "https://github.com/laurentiuene"
    },
    {
      "name": "Ioana Lazar",
      "email": "ioana.pascu9596@gmail.com",
      "url": "https://github.com/Ioana-Sofia-Lazar"
    },
    {
      "name": "Gabriel Andrei",
      "email": "gabrielandrei.ga@gmail.com",
      "url": "https://github.com/GabiAD"
    }
  ],
  "engines": {
    "node": ">=24.11.0",
    "npm": "^11.6.1"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:base": "ng build",
    "build:local": "npm run build:base -- --configuration local && npm run postbuild && npm run sentry:sourcemaps",
    "build:dev": "npm run build:base -- --configuration dev && npm run postbuild && npm run sentry:sourcemaps",
    "build:prod": "npm run build:base -- --configuration prod && npm run postbuild && npm run sentry:sourcemaps",
    "watch": "ng build --watch --configuration local",
    "test": "ng test",
    "test:ci": "ng test --no-watch --browsers=ChromeHeadless",
    "test:coverage": "ng test --no-watch --code-coverage",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "serve:ssr": "node dist/waytr-qr/server/server.mjs",
    "sonar": "node sonar-project.js",
    "prettier-format": "prettier --config .prettierrc \"src/**/*.{html,ts,scss,json}\" --write",
    "purge-css": "node ./purgecss.cjs",
    "generate-icons": "svg-to-ts-files",
    "postbuild": "run-p purge-css compress",
    "compress": "gulp compress",
    "i18n-extract": "ngx-translate-extract --cache-file ./ --input ./src --output './src/assets/i18n/template.json' -s -sp --format namespaced-json -k --fi -c",
    "analyze": "webpack-bundle-analyzer dist/waytr-qr/browser/stats.json",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org andrei-lazar --project waytr-qr ./dist/waytr-qr && sentry-cli sourcemaps upload --org andrei-lazar --project waytr-qr --ignore node_modules ./dist/waytr-qr"
  },
  "private": true,
  "husky": {
    "hooks": {
      "pre-commit": "lint-staged"
    }
  },
  "lint-staged": {
    "*.{ts,js}": [
      "prettier --write",
      "eslint --fix",
      "git add"
    ],
    "*.{html,css,scss,json}": [
      "prettier --write",
      "git add"
    ]
  },
  "svg-to-ts": {
    "modelFileName": "waytr-icons",
    "iconsFolderName": "icons",
    "verbose": true,
    "srcFiles": [
      "./src/assets/icons/*.svg"
    ],
    "outputDirectory": "./src/app/shared/components/waytr-icons",
    "interfaceName": "IWaytrIcon",
    "typeName": "waytrIconType",
    "prefix": "waytr",
    "svgoConfig": {
      "plugins": [
        "cleanupAttrs"
      ]
    },
    "additionalModelOutputPath": "./src/app/shared/components/waytr-icons",
    "compileSources": true
  },
  "type": "module",
  "sideEffects": [
    "*.scss",
    "*.css",
    "*.less"
  ],
  "dependencies": {
    "@angular/animations": "^20.3.16",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.16",
    "@angular/compiler": "^20.3.16",
    "@angular/core": "^20.3.16",
    "@angular/forms": "^20.3.16",
    "@angular/platform-browser": "^20.3.16",
    "@angular/platform-browser-dynamic": "^20.3.16",
    "@angular/platform-server": "^20.3.16",
    "@angular/router": "^20.3.16",
    "@angular/service-worker": "^20.3.16",
    "@angular/ssr": "^20.3.15",
    "@ant-design/icons-angular": "^20.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@sentry/angular": "^10.36.0",
    "@sentry/cli": "^2.58.4",
    "jwt-decode": "^4.0.0",
    "lodash-es": "^4.17.23",
    "ng-zorro-antd": "^20.4.4",
    "rxjs": "^7.4.0",
    "socket.io-client": "^4.8.3",
    "ua-parser-js": "^2.0.8",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.15",
    "@angular-eslint/builder": "20.5.0",
    "@angular-eslint/eslint-plugin": "20.5.0",
    "@angular-eslint/eslint-plugin-template": "20.5.0",
    "@angular-eslint/schematics": "20.5.0",
    "@angular-eslint/template-parser": "20.5.0",
    "@angular/cli": "^20.3.15",
    "@angular/compiler-cli": "^20.3.16",
    "@types/eslint": "^9.6.1",
    "@types/express": "^5.0.5",
    "@types/gulp": "^4.0.18",
    "@types/jasmine": "^5.1.12",
    "@types/karma": "^6.3.9",
    "@types/karma-chrome-launcher": "^3.1.4",
    "@types/karma-coverage": "^2.0.3",
    "@types/karma-jasmine": "^4.0.5",
    "@types/karma-jasmine-html-reporter": "~1.7.3",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^24.9.2",
    "@types/ua-parser-js": "^0.7.39",
    "@typescript-eslint/eslint-plugin": "8.46.2",
    "@typescript-eslint/parser": "8.46.2",
    "@vendure/ngx-translate-extract": "^10.1.0",
    "esbuild-plugin-env": "^1.1.1",
    "eslint": "9.38.0",
    "express": "^5.1.0",
    "gulp": "^5.0.1",
    "gulp-brotli": "^3.0.0",
    "gulp-gzip": "^1.4.2",
    "helmet": "^8.1.0",
    "husky": "^9.1.7",
    "jasmine-core": "^5.12.1",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^16.2.6",
    "npm-run-all": "^4.1.5",
    "prettier": "^3.6.2",
    "purgecss": "^7.0.2",
    "purgecss-webpack-plugin": "^7.0.2",
    "sonarqube-scanner": "^4.3.2",
    "svg-to-ts": "^12.0.0",
    "typescript": "5.9.3",
    "webpack-bundle-analyzer": "^4.10.2"
  },
  "optionalDependencies": {
    "bufferutil": "^4.0.8",
    "lmdb": "^3.4.3",
    "utf-8-validate": "^6.0.5"
  },
  "overrides": {
    "rollup": "npm:@rollup/wasm-node"
  }
}
